var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "quick-actions-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "xl",
    },
    on: { hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-title" }, [
              _c(
                "div",
                { staticClass: "d-flex flex-sm-row flex-column" },
                [
                  _c("h5", { staticClass: "bold mb-0" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.create")) +
                        " " +
                        _vm._s(_vm._f("toUppercase")(_vm.quickActionName)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "bold mb-0" }, [
                    _vm._v(" " + _vm._s(_vm.$t("global.words.for")) + " "),
                  ]),
                  _vm._v(" "),
                  _c("client-profile-dropdown", {
                    attrs: {
                      "linked-profiles": _vm.clientProfiles,
                      "selected-linked-profile": _vm.linkedClientProfile,
                      boards: _vm.boards,
                    },
                    on: { select: _vm.handleSelectedProfile },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loadingProfile
              ? _c("default-body-loader")
              : _c(_vm.getQuickActionComponent(_vm.quickActionName), {
                  tag: "component",
                  attrs: {
                    "client-profile-id": _vm.clientProfileId,
                    "current-tab": _vm.quickActionName,
                    profile: _vm.profileData,
                    external: "",
                  },
                }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }